import React, {forwardRef, MouseEvent, MutableRefObject, useCallback, useContext} from 'react';
import cx from 'classnames';
import {DropDownV2Context, Icon, PriorityIcon} from '@priority-software/priority-style-react';
import styles from './styles.module.scss';

export type Props = {
    filtersCount: number;
    text?: string;
    componentClasses?: string;
    paddingX?: string;
};

export const TriggerButton = forwardRef<HTMLDivElement, Props>((props, ref) => {
    const {isOpen, openDropdown, closeDropdown, disabled} = useContext(DropDownV2Context);

    const handleToggle = useCallback(
        (e: MouseEvent<HTMLDivElement>) => {
            if (isOpen) {
                closeDropdown();
            } else {
                e.currentTarget.blur();
                openDropdown();
            }
        },
        [isOpen, closeDropdown, openDropdown]
    );

    return (
        <div
            ref={ref as MutableRefObject<HTMLDivElement>}
            onClick={disabled ? undefined : handleToggle}
            className={cx(styles.component, props.componentClasses, {
                [styles.open]: isOpen,
                [styles.disabled]: disabled
            })}
            style={{'--padding-x': props.paddingX || '12px'} as React.CSSProperties}
        >
            <Icon icon={PriorityIcon.filter} size="small" counterValue={props.filtersCount} />

            <span className={styles.label}>{props.text || ''}</span>

            <Icon icon={isOpen ? PriorityIcon.arrowUpThin : PriorityIcon.arrowBottomThin} />
        </div>
    );
});
